import { render, staticRenderFns } from "./strategyDetail.vue?vue&type=template&id=a4d1367c&scoped=true&"
import script from "./strategyDetail.vue?vue&type=script&lang=js&"
export * from "./strategyDetail.vue?vue&type=script&lang=js&"
import style0 from "./strategyDetail.vue?vue&type=style&index=0&id=a4d1367c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d1367c",
  null
  
)

export default component.exports